import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,

  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
    backgroundColor: '#153bab',
    color: '#ffffff' ,

  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  content: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    padding: theme.spacing(3),

  },

}));

export default function PermanentDrawerLeft(props) {
  const classes = useStyles();
  const query = props.query;
  console.log(query)
  return (
    <div className={classes.root}>
      <Drawer
        className={classes.drawer}
        variant="permanent"
        classes={{
          paper: classes.drawerPaper,
        }}
        anchor="left"
      >
        <div className={classes.toolbar} />

        <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop:'73px'}}>
        <img className="avatar" src={query.picture} alt="avatar" style={{width: "80px", borderRadius: 400/ 2}}/>
        </div>

        <h4 className="name" style={{display: "flex", justifyContent: "center", alignItems: "center",}}>{query.name}</h4>
        <h5 className="job" style={{display: "flex", justifyContent: "center", alignItems: "center",}}>{query.title}</h5>

<hr/>
        <List>
          {/* {['Job Postings', 'Projects'].map((text, index) => (
            <ListItem button key={text}>
              <ListItemText primary={text} style={{display: "flex", justifyContent: "center", alignItems: "center",}} />
            </ListItem>
          ))} */}
        </List>
      </Drawer>

    </div>
  );
}
